var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThermometer03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0013 7.50033L35.0013 7.50033M49.0013 16.8337L35.0013 16.8337M49.0013 26.167L35.0013 26.167M12.8346 32.6018V11.0003C12.8346 7.77866 15.4463 5.16699 18.668 5.16699C21.8896 5.16699 24.5013 7.77866 24.5013 11.0003V32.6018C27.3153 34.4854 29.168 37.6932 29.168 41.3337C29.168 47.1326 24.467 51.8337 18.668 51.8337C12.869 51.8337 8.16797 47.1326 8.16797 41.3337C8.16797 37.6932 10.0207 34.4854 12.8346 32.6018ZM21.0013 41.3337C21.0013 42.6223 19.9566 43.667 18.668 43.667C17.3793 43.667 16.3346 42.6223 16.3346 41.3337C16.3346 40.045 17.3793 39.0003 18.668 39.0003C19.9566 39.0003 21.0013 40.045 21.0013 41.3337Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometer03);
export default __webpack_public_path__ + "static/media/thermometer-03.f697056fe2eb8f52397dc5dff8761dde.svg";
export { ForwardRef as ReactComponent };